import script from "./GestionPagosF.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionPagosF.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__